// Government.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../AuthContext";
import "../styles/Government.css";
import GovernmentRegisterModal from "./GovernmentRegisterModal";
import GovernmentEditModal from "./GovernmentEditModal";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Government = () => {
    const { user, setUser } = useAuth();
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;
    const [isModalOpen, setIsModalOpen] = useState(false); // 모달 상태 관리
    const [searchField, setSearchField] = useState("all");  // 라디오 버튼에서 선택된 항목
    const [searchKeyword, setSearchKeyword] = useState("");  // 검색 키워드
    const [selectedGovernment, setSelectedGovernment] = useState(null);

    const handleRowClick = (Government) => {
        setSelectedGovernment(Government);
    };

    const handleSaveGovernment = (updatedGovernment) => {
        setUsers(users.map((u) => (u.snum === updatedGovernment.snum ? updatedGovernment : u)));
    };

    const handleSearch = () => {
        fetchUsers(searchField, searchKeyword);  // 필터링된 값으로 다시 fetch 호출
    };

    const handleSearchFieldChange = (e) => {
        const selectedValue = e.target.value;
        setSearchField(e.target.value);  // 선택된 콤보박스 값 설정
        // "회원구분"을 선택하면 기본값 설정
        if (selectedValue === "userType") {
            setSearchKeyword("S"); // 기본값을 "S"로 설정 (빛담관리자)
        } else {
            setSearchKeyword(""); // 다른 경우 입력값 초기화
        }
    };

    const handleSearchKeywordChange = (e) => {
        setSearchKeyword(e.target.value);  // 검색어 값 설정
    };

    const handleUserTypeChange = (e) => {
        setSearchKeyword(e.target.value); // 선택한 값(S, P, G, U) 저장
    };
    

    // 기존의 fetchUsers 함수에 검색 필터 추가
    const fetchUsers = async (searchField, searchKeyword) => {
        try {
            const queryParams = new URLSearchParams({
                page,
                pageSize,
                searchField,
                searchKeyword
            });

            const response = await fetch(`${API_BASE_URL}/api/Government/get-government?${queryParams}`);
            const data = await response.json();

            if (response.ok) {
                setUsers(data.users);
                setTotalPages(Math.ceil(data.totalRecords / pageSize));
            } else {
                console.log(data.message || "조회 실패");
            }
        } catch (error) {
            console.error("조회 실패:", error);
            alert("서버 오류 발생");
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // 페이지 로드 시 실행

    useEffect(() => {
        fetchUsers(searchField, searchKeyword);
    }, [page]);

    useEffect(() => {
        const validTotalPages = totalPages > 0 ? totalPages : 1; // totalPages가 0 또는 null이면 1로 설정

        if (page > validTotalPages) {
            setPage(validTotalPages);  // 현재 선택된 페이지가 전체 페이지보다 크면 마지막 페이지로 이동
        }
    }, [totalPages]);  // totalPages가 변경될 때 실행

    // ✅ 사용자 추가 후 호출될 콜백 함수
    const handleGovernmentAdded = () => {
        setSearchField("");
        setSearchKeyword("");
        fetchUsers(searchField, searchKeyword);  // 사용자 추가 후 다시 목록 로드
    };

    const handleAddGovernmentClick = () => {
        setIsModalOpen(true); // 팝업 열기
    };

    const closePopup = () => {
        setIsModalOpen(false); // 팝업 닫기
    };

    const renderPagination = () => {
        if (totalPages <= 10) {
            return [...Array(totalPages)].map((_, index) => (
                <button
                    key={index + 1}
                    className={page === index + 1 ? "active" : ""}
                    onClick={() => setPage(index + 1)}
                >
                    [{index + 1}]
                </button>
            ));
        }
        let pages = [];
        if (page <= 6) {
            pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, "...", totalPages];
        } else if (page >= totalPages - 5) {
            pages = [1, "...", totalPages - 8, totalPages - 7, totalPages - 6, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
            pages = [1, "...", page - 3, page - 2, page - 1, page, page + 1, page + 2, page + 3, "...", totalPages];
        }

        return pages.map((p, index) => (
            <button
                key={index}
                className={page === p ? "active" : ""}
                onClick={() => typeof p === "number" && setPage(p)}
                disabled={typeof p !== "number"}
            >
                [{p}]
            </button>
        ));
    };

    return (
        <div className="government-wrapper">
            <div className="government-header">
                {/*<h1>관할 관공서</h1> */}          
                <h1>관할관공서 <span style={{ fontSize: "0.7em", color: "gray" }}>{`Admin > ${user.name}`}</span></h1>
                
                <button className="add-button" onClick={handleAddGovernmentClick}>+</button> {/* + 버튼 */}
            </div>
            <hr className="title-line" />

            {/* ✅ 모달 창 표시 (GovernmentRegisterModal.js에 handleUserAdded 전달) */}
            {isModalOpen && <GovernmentRegisterModal onClose={() => setIsModalOpen(false)} onGovernmentAdded={handleGovernmentAdded} />}

            {/* 검색 섹션 */}
            <div className="search-container">
                <label>
                    <select value={searchField} onChange={handleSearchFieldChange}>
                        <option value="all">전체조회</option>
                        <option value="governmentCode">관공서코드</option>
                        <option value="governmentName">관공서명</option>                        
                        <option value="addressAll">주소</option>
                    </select>
                </label>

                {/* 검색어 입력 (전체조회) */}
                {searchField !== "all" && (
                    <label>

                        <input
                            type="text"
                            value={searchKeyword}
                            onChange={handleSearchKeywordChange}
                            maxLength={18}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSearch(); // 
                                }
                            }}
                        />
                    </label>
                )}

                <button onClick={handleSearch}>검색</button>
            </div>

            <div className="government-container">
                <ul className="government-list">
                    <li className="government-header-row">
                        <span className="snum">순번</span>
                        <span className="governmentCode">관공서코드</span>
                        <span className="governmentName">관공서명</span>
                        <span className="address1">소재지1</span>
                        <span className="address2">소재지2</span>
                    </li>
                    <hr className="thick-line" />

                    {users.map((Government, index) => (
                        <React.Fragment key={Government.snum}>
                            <li className="government-row" onClick={() => handleRowClick(Government)}>
                                <span className="snum">{Government.snum}</span>
                                <span className="governmentCode">{Government.governmentCode}</span>
                                <span className="governmentName">{Government.governmentName}</span>                                
                                <span className="address1">{Government.location1}</span>
                                <span className="address2">{Government.location2}</span>  
                            </li>
                            <hr className="thin-line" />
                        </React.Fragment>
                    ))}

                    {selectedGovernment && <GovernmentEditModal selectedGovernment={selectedGovernment} onClose={() => setSelectedGovernment(null)} onSave={handleSaveGovernment} onGovernmentAdded={handleGovernmentAdded} />}
                    <hr className="thick-line" />
                </ul>
                <div className="pagination">{renderPagination()}</div>
            </div>

        </div>



    );
};

export default Government;